var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"btn-my-primary text-nowrap",attrs:{"disabled":!_vm.enabledNewTask},on:{"click":_vm.createTask}},[_vm._v(" Создать новую задачу ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }